// FILECONTENT_START src/common/components/Inputs/Price/Price.tsx
import { Euro } from "@mui/icons-material";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { TextField, TextFieldProps } from "common";
import { useExchangeRate } from "features/exchange-rates/ExchangeRateProvider";

export interface PriceProps extends TextFieldProps {
  count?: number;
  mode?: "normal" | "total";
  currencyOverride?: Currency;
}
type Currency = "HUF" | "EUR";
export default function Price({
  size,
  sx,
  count = 1,
  mode = "normal",
  currencyOverride,
  value,
  onChange,
  helperText: _helperText,
  ...props
}: PriceProps) {
  const { exchangeRate, currency } = useExchangeRate();
  const effectiveCurrency = currencyOverride || currency;
  const rate = exchangeRate?.rate;

  const toEur = (rawValue: any) => {
    if (rawValue === "" || rawValue === null || rawValue === undefined) {
      return rawValue;
    }
    const num =
      typeof rawValue === "number" ? rawValue : parseFloat(String(rawValue));
    if (Number.isNaN(num)) {
      return rawValue;
    }
    if (effectiveCurrency === "HUF" && rate) {
      return num / rate;
    }
    return num;
  };

  const fromEur = (rawValue: any) => {
    if (rawValue === "" || rawValue === null || rawValue === undefined) {
      return rawValue;
    }
    const num =
      typeof rawValue === "number" ? rawValue : parseFloat(String(rawValue));
    if (Number.isNaN(num)) {
      return rawValue;
    }
    if (effectiveCurrency === "HUF" && rate) {
      return num * rate;
    }
    return num;
  };

  const displayValue =
    mode === "total" && typeof value === "number" ? value * count : value;

  const handleChange = (event: {
    target: { value?: string | number | null };
  }) => {
    let newValue = toEur(event.target.value);

    if (mode === "total" && typeof newValue === "number") {
      newValue = newValue / count;
    }
    if (onChange) {
      onChange({ target: { value: newValue } });
    }
  };
  let floatValue = parseFloat((value as any) || 0);
  let v = mode === "total" ? floatValue * count : floatValue;
  let vRounded = Math.round(v * 100000) / 100000;
  let helperText =
    effectiveCurrency !== "EUR"
      ? `${vRounded} EUR (1 EUR = ${exchangeRate?.rate} Ft)`
      : undefined;

  const displayCurrencyValue = fromEur(displayValue);

  if (_helperText) {
    if (helperText) {
      helperText = helperText + " " + _helperText;
    } else {
      helperText = _helperText;
    }
  }
  return (
    <TextField
      mask={Number}
      numberOptions={{
        scale: 5,
      }}
      unmask
      size="small"
      value={displayCurrencyValue}
      onChange={handleChange}
      sx={{
        ...(size === "small"
          ? {
              minHeight: "27px",
              "& input": {
                padding: "3px",
                paddingLeft: "8px",
                paddingRight: "8px",
              },
            }
          : {
              "& .MuiInputBase-root": { paddingRight: "0px" },
              "& input": {
                paddingRight: "0px!important",
              },
            }),
        ...sx,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disabled
              sx={{
                backgroundColor: theme => theme.palette.action.hover,
                borderRadius: "4px",
                cursor: "default",
                pointerEvents: "none",
              }}
            >
              {effectiveCurrency === "HUF" && (
                <Box
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    color: !exchangeRate?.rate ? "error.main" : "info.main",
                    border: theme => `solid 1px ${theme.palette.info.main}`,
                    borderRadius: "2px",
                    px: "3px",
                    py: "1px",
                  }}
                >
                  Ft
                </Box>
              )}
              {effectiveCurrency !== "HUF" && (
                <Euro
                  fontSize="small"
                  color={props.disabled ? "disabled" : undefined}
                />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
      helperText={helperText}
    />
  );
}
// FILECONTENT_END src/common/components/Inputs/Price/Price.tsx
